import useSessionEffect from "hooks/useSessionEffect";
import { useRequest } from "hooks";
import { ThunkReturnType } from "types";
import type { ConstantsResponse } from "features/general/types";
import useCountries from "features/general/useCountries";
import useFetchPaymentMethods from "features/paymentMethods/useFetchPaymentMethods";
import { getOnboardingsConstantsThunk } from "./thunks";
import { getOnboardingsCountries, getOnboardingsPaymentMethods } from "./api";

const onboardingSessionEffectSymbol = Symbol("onboardingSessionEffect");

export const useOnboardingBootstrap = () => {
    const getConstants = useRequest<ThunkReturnType<ConstantsResponse>, void>({
        thunk: getOnboardingsConstantsThunk,
    });

    useCountries({
        resourceRequest: getOnboardingsCountries
    });

    const getPaymentMethods = useFetchPaymentMethods({
        resourceRequest: getOnboardingsPaymentMethods
    });

    useSessionEffect(() => {
        getConstants();
        getPaymentMethods();
    }, onboardingSessionEffectSymbol);
};

export default useOnboardingBootstrap;
